import React from 'react';
import trackAnalytics from '../../utils/gaia/trackAnalytics';

export default class CopyLinkButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    render() {
        return (
            <span>
                <a className='ga-button ga-button-flat'
                    title="Copy Link"
                    onClick={e => { e.preventDefault(); this.copyToClipboard(); }}
                >
                    <i className="material-icons ibmid">link</i>&nbsp;
                    <span className="ibmid">Copy Link</span>
                </a>
                {this.state.open &&
                    <div
                        className="alert alert-success"
                        style={{position: 'absolute', zIndex: 999}}
                    >
                        Link copied! To paste it, press ctrl-v (Windows), or cmd-v (Mac).
                    </div>
                }
            </span>
        );
    }

    // Use a well-supported method for adding to the clipboard.
    // There's a new API that might get adopted later too:
    // https://stackoverflow.com/a/30810322/108512
    copyToClipboard() {
        this.setState({open: true});
        const text = `https://www.gaiagps.com${window.location.pathname}`;
        trackAnalytics('Copy to Clipboard', {category: 'Hike', url: text});
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.insertBefore(textArea, document.body.firstChild);
        textArea.focus();
        textArea.select();
        const successful = document.execCommand('copy');
        if (successful) {
            this.setState({open: true});
        }
        document.body.removeChild(textArea);
        sleep(2000).then(() => {
            this.setState({open: false});
        });
    }
}


// sleep time expects milliseconds
function sleep(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}
